/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateCheckoutSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateCheckoutRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CreateCheckoutSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateCheckoutSecurity$outboundSchema: z.ZodMiniType<
  CreateCheckoutSecurity$Outbound,
  CreateCheckoutSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createCheckoutSecurityToJSON(
  createCheckoutSecurity: CreateCheckoutSecurity,
): string {
  return JSON.stringify(
    CreateCheckoutSecurity$outboundSchema.parse(createCheckoutSecurity),
  );
}

/** @internal */
export type CreateCheckoutRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateCheckoutRequest$outboundSchema: z.ZodMiniType<
  CreateCheckoutRequest$Outbound,
  CreateCheckoutRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function createCheckoutRequestToJSON(
  createCheckoutRequest: CreateCheckoutRequest,
): string {
  return JSON.stringify(
    CreateCheckoutRequest$outboundSchema.parse(createCheckoutRequest),
  );
}
